export default "__VITE_ASSET__qGEYgiZO__"